import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=9bed0dbc&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9bed0dbc')) {
      api.createRecord('9bed0dbc', component.options)
    } else {
      api.reload('9bed0dbc', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=9bed0dbc&", function () {
      api.rerender('9bed0dbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-26v8HCBm4d7RV/JS/offershelp.vue"
export default component.exports